<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-row>
      <v-col cols="8">
        <v-card-title>
          Optic Lens Setup
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <template>
            <v-text-field
                v-model="search"
                prepend-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                outlined
                dense
            ></v-text-field>
          </template>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="modalOpen()"
          ><v-icon>mdi-plus</v-icon></v-btn
          >
        </v-card-title>

        <v-card>
          <v-data-table
              :headers="headers"
              :items="dessert"
              class="elevation-1"
              :search="search"
              dense
              mobile-breakpoint="0"
              :loading="loading_status"
              loading-text="Loading... Please wait"
          >
            <template v-slot:item.status="{ item }">
              <v-chip v-if="item.status === 1" dark color="green" label outlined small>Active</v-chip>
              <v-chip v-if="item.status === 0" dark color="orange" label outlined small>Inactive</v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                      @click="get_update(item.id)"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ma-2"
                      color="orange"
                      label
                      outlined
                      small
                  ><v-icon> mdi-pencil </v-icon>
                  </v-chip>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="get_optic_lens_data()">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>


    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Optic Lens Setup
              <span v-if="dessert.name">: {{ dessert.name }}</span></v-card-title>
            <template>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          v-model="submitData.name"
                          outlined
                          dense
                          label="Name"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" >
                      <v-select
                          v-model="submitData.type"
                          :items="types"
                          item-value="key"
                          item-text="value"
                          label="Type"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                    <v-col cols="12" >
                      <v-select
                          v-model="submitData.version"
                          :items="versions"
                          item-value="key"
                          item-text="value"
                          label="Version"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                    <v-col cols="12" >
                      <v-select
                          v-model="submitData.status"
                          :items="statuses"
                          item-value="key"
                          item-text="value"
                          label="Status"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </template>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialog = false"> Cancel </v-btn>
              <v-btn color="primary" text @click="opticLensSetupSubmit()"> Submit </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      search: "",
      auto_search: "",
      dialog: false,
      loading_status: true,
      dessert: [],
      types: ['type', 'material', 'coating', 'instruction', 'tips', 'brand'],
      versions: ['en', 'bn'],
      statuses: [
        { key: 1, value: "Active" },
        { key: 0, value: "Inactive" },
      ],
      headers: [
        { text: "Name", value: "name" },
        { text: "Type", value: "type" },
        { text: "Version", value: "version" },
        { text: "Status", value: "status" },
        { text: "Action", value: "actions", sortable: false },
      ],
      submitData: {
        id: '',
        name: '',
        type: '',
        version: '',
        status: '',
        user_id: localStorage.getItem("userId")
      },
      items: [
        {text: "Dashboard", disabled: false, href: "/",},
        {text: "Administrative", disabled: true, href: "",},
        {text: "Optic Lens Setup", disabled: true, href: "",},
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  created() {
    // this.permissionCheck();
    this.get_optic_lens_data();
  },
  methods: {
    // permissionCheck() {
    //   atshq
    //       .get("users/user-group?id=" + localStorage.getItem("userId"))
    //       .then((response) => {
    //         if (!response.data.data.includes("ot-setup")) {
    //           this.$router.go(-1);
    //         }
    //       })
    //       .catch((e) => {
    //         this.errors.push(e);
    //       });
    // },
    get_optic_lens_data() {
      atshq
          .get("administrative/optic-lens-setup")
          .then((response) => {
            this.dessert = response.data.optic_lens_setups;
            this.loading_status = false;
          })
          .catch((e) => {
            console.log(e)
          });
    },
    get_update(id) {
      atshq
          .get("administrative/optic-lens-setup/" + id)
          .then((res) => {
            var item = res.data.optic_lens_setup
            this.submitData.id = id
            this.submitData.name = item.name
            this.submitData.type = item.type
            this.submitData.version = item.version
            this.submitData.status = item.status
            this.dialog = true;
          })
          .catch((e) => {
            this.$noty.error(e.response.data.message)
          })
    },
    modalOpen() {
      this.dialog = true
      this.clearOpticLensSetupData()
    },
    clearOpticLensSetupData() {
      this.submitData.id = ''
      this.submitData.name = ''
      this.submitData.type = ''
      this.submitData.version = ''
      this.submitData.status = ''
    },
    opticLensSetupSubmit() {
      console.log(this.submitData)
      if (confirm("are you sure?"))
        if (this.submitData.id) {
          atshq
              .put("administrative/optic-lens-setup/" + this.submitData.id, {
                formdata: this.submitData,
                user_id: localStorage.getItem("userId"),
              })
              .then((res) => {
                this.$noty.success(res.data.message);
                this.get_optic_lens_data();
                this.dialog = false;
              })
              .catch((e) => {
                this.$noty.error(e.response.data.message)
              })
        } else {
          atshq
              .post("administrative/optic-lens-setup", {
                formdata: this.submitData,
                user_id: localStorage.getItem("userId"),
              })
              .then((res) => {
                this.$noty.success(res.data.message);
                this.get_optic_lens_data();
                this.dialog = false;
              })
              .catch((e) => {
                this.$noty.error(e.response.data.message)
              })
        }
    },
  },
};
</script>
